
import { MultigameParams } from "../../MultigameParams";
import { RewardColor } from "../../slot/ScatterRandomAward/RewardOptionFactory";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusPickElementParams, PickBonusReward } from "../PickBonus/PickBonusParams";
import { SlotGameType1 } from "../SlotGameType1";

// namespace SlotGames {

	export class AncientSea extends SlotGameType1 {

		// override default factory with one that creates custom ancient sea freegame
		////protected override freegameBonusFactory: FreegameBonusFactory = new AncientSeaFreegameBonusFactory();
		protected override pickBonusFactory: PickBonusFactory = new AncientSeaPickBonusFactory();
		protected reward: PickBonusReward = null;
		
		//protected panelFactory:IPanelFactory = new AncientSeaPanelFactory();
		//LED COLOR
		protected override ColorLed:string="0,0,255\n";

		//SEND COLOR 
        protected override color: RewardColor = 
        {
            color: "white",
		    coloroutherStroke: "black",
            colorinnerStroke: "#00AAE4",
        }


		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "AncientSea");

			this.spinnableReelsParams.topBorderWidth = 10;
			this.spinnableReelsParams.bottomBorderWidth = 10;
		}
	}

	// class AncientSeaFreegame extends FreegameBonus {
	// 	public constructor(gameName: string, params: FreegameBonusParams) {
	// 		super(gameName, params);
	// 		this.spinnableReelsParams.topBorderWidth = 10;
	// 		this.spinnableReelsParams.bottomBorderWidth = 10;
	// 	}
	// 	// protected PrepareMessage(resourceManager: ResourceManager)
	// 	// {
	// 	// 	super.PrepareMessage(resourceManager);



	// 	// 	//////////Style to Freegame text
	// 	// 	SetStyles(this.view.querySelectorAll(".dialogContainer"),{
	// 	// 		textShadow:"4px 5px black",
	// 	// 		webkitTextStroke: "2px", webkitTextStrokeColor: "black"
	// 	// 	})
			

	// 	// 	SetStyles(this.view.querySelectorAll("#contents3"),{
	// 	// 		fontSize:"40px"
	// 	// 	});
			
			
	// 	// 	SetStyles(this.view.querySelectorAll("#startend3"),{fontSize:"40px", bottom:"230px"});
	// 	// }


	// 	protected override PreparePickIntroMessage(resourceManager: ResourceManager): void
	// 	{
	// 		super.PreparePickIntroMessage(resourceManager);
	// 		let m: HTMLElement = this.pickIntroMessageContainer.querySelector(".pickMessageContainer");
	// 		m.style.textShadow = "4px 5px black";
	// 		m.style.webkitTextStroke = "2px";
	// 		m.style.webkitTextStrokeColor = "black";
	// 	}

	// 	protected override PreparePicksContainer(resourceManager: ResourceManager): void
	// 	{
	// 		super.PreparePicksContainer(resourceManager);
	// 		this.picksContainer.style.textShadow = "4px 5px black";
	// 		this.picksContainer.style.webkitTextStroke = "2px";
	// 		this.picksContainer.style.webkitTextStrokeColor = "black";
	// 	}

	// 	protected override PreparePickMessageContainer(resourceManager: ResourceManager): void
	// 	{
	// 		super.PreparePickMessageContainer(resourceManager);
	// 		let m: HTMLElement = this.pickedMessageContainer.querySelector(".messageContainer");
	// 		m.style.textShadow = "4px 5px black";
	// 		m.style.webkitTextStroke = "2px";
	// 		m.style.webkitTextStrokeColor = "black";
	// 	}

	// 	protected override PrepareFinalMessage(resourceManager: ResourceManager): void
	// 	{
	// 		super.PrepareFinalMessage(resourceManager);
	// 		let m: HTMLElement = this.finalMessageContainer.querySelector(".messageContainer");
	// 		m.style.textShadow = "4px 5px black";
	// 		m.style.webkitTextStroke = "2px";
	// 		m.style.webkitTextStrokeColor = "black";
	// 	}


	// 	public override OnPicked(index: number): void {
	// 		//super.OnPicked(index);

	// 		if (this.stateMachine.State() == FreegameStates.Pick) {
	// 			// Log.Debug(this.logGroup, "Picked index " + index);

	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});

	// 			for (let i = 0; i < this.picks.length; i++) {
	// 				if (i == index) {
	// 					this.picks[i].BringToFront();
	// 					this.picks[i].awardElem.style.fontSize = "130px";
	// 					this.picks[i].awardElem.style.left = 140 + "px";
	// 					this.picks[i].awardElem.style.top = 130 + "px";
	// 				}
	// 				else {
	// 					this.picks[i].PushToBack();
	// 				}
	// 			}

	// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
	// 		}
	// 	}

	// 	protected override PicksPositions(): FreegamePickElemGeometry[] {
	// 		// align award to be in the box, when box opens
	// 		let geometry: FreegamePickElemGeometry[] = [];

	// 		let displayWidth: number = 540;
	// 		let displayHeight: number = 510;

	// 		let displayRects: PixelRect[] =
	// 			[
	// 				new PixelRect(21, 328, displayWidth, displayHeight),
	// 				new PixelRect(363, 528, displayWidth, displayHeight),
	// 				new PixelRect(705, 328, displayWidth, displayHeight),
	// 				new PixelRect(1044, 528, displayWidth, displayHeight),
	// 				new PixelRect(1386, 328, displayWidth, displayHeight),
	// 			];

	// 		// offset relative to pick rect
	// 		let pickRect = new PixelRect(107, 150, 282, 269);
	// 		let awardRect = new PixelRect(109, 172, 280, 245);//let awardRect = new PixelRect(150, 90, 260, 280);

	// 		for (let i = 0; i < displayRects.length; i++) {
	// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect, awardRect));
	// 		}

	// 		return geometry;
	// 	}


	// }


	// class AncientSeaFreegamePickElement extends FreegamePickElement {
	// 	public override AwardElemePrepare() {
	// 		super.AwardElemePrepare();
	// 		this.awardElem.style.left = "140px";
	// 		this.awardElem.style.top = "110px";
	// 		this.awardElem.style.fontSize = "70px";



	// 	}


	// }

	//Panel Colorized
	class AncientSeaPanelFactory implements IPanelFactory
	{
		public CreateNewPanel(params: PanelParams):Panel
		{
			return new AncientSeaPanel(params);
		}
	}

	class AncientSeaPanel extends Panel
	{
		protected override ButtonBackground():ButtonColors
		{
			let color:ButtonColors ={
				backgroundButtonColor: "linear-gradient(rgb(1, 11, 64),rgb(2, 15, 89), rgb(3, 23, 140),rgb(2, 15, 89),rgb(1, 11, 64)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor:"linear-gradient(to left , transparent, dodgerblue,transparent ) 0 10 100%",
			};
			return color;
			
		}
	}

	// class AncientSeaFreegameBonusFactory extends FreegameBonusFactory {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus {
	// 		return new AncientSeaFreegame(gameName, params);
	// 	}
	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement {
	// 		return new AncientSeaFreegamePickElement(params);
	// 	}
	// }

	class AncientSeaPickBonusElement extends PickBonusElement {
	}

	class AncientSeaPickBonusFactory extends PickBonusFactory {
		public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement {
			return new AncientSeaPickBonusElement(params);
		}
	}











// }
